import { ClarityType } from '../clarityValue.esm.js';

var trueCV = function trueCV() {
  return {
    type: ClarityType.BoolTrue
  };
};

var falseCV = function falseCV() {
  return {
    type: ClarityType.BoolFalse
  };
};

export { falseCV, trueCV };
//# sourceMappingURL=booleanCV.esm.js.map
